import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { log } from '../../utils/logger';
import "./Anketa.css";

export const EmailConfirmation = () => {
    const navigate = useNavigate();

    useEffect(() => {
        log('EmailConfirmation', 'Страница «Подтвердите email»');
    }, []);

    return (
        <div className="anketa-container">
            <div className="register-card">
                <div className="question-section">
                    <h2 className="question-text">Подтвердите адрес электронной почты</h2>
                    <p className="question-hint">
                        Мы отправили письмо с подтверждением на ваш адрес электронной почты.
                        Пожалуйста, проверьте почту и перейдите по ссылке для подтверждения.
                    </p>
                </div>

                <div className="navigation-section">
                    <button className="nav-btn prev-btn" onClick={() => { log('EmailConfirmation', 'Переход на главную'); navigate("/"); }}>
                        ← На главную
                    </button>
                </div>
            </div>
        </div>
    );
};
